import ReactTimeAgo from "react-time-ago";
import { getQuarter } from "../../../../utils";
import { Text, Skeleton, Box } from "@mantine/core";
// CommitmentsCell Component
export const CommitmentsCell: React.FC<any> = ({
  data,
  isAllowedToEditDates,
}) => {
  const closestDate = data.aggregations?.committed?.closest;
  
  if (!closestDate) {
    return <Text></Text>;
  }
  
  if (!isAllowedToEditDates) {
    return <Text>{getQuarter(new Date(closestDate))}</Text>;
  } else {
    return <ReactTimeAgo date={new Date(closestDate)} />;
  }
};

// Skeleton component for CommitmentsCell
export const CommitmentsCellSkeleton: React.FC<{ col: any }> = ({ col }) => {
  const columnWidth = col.width;
  const minWidth = col.minWidth;
  const maxWidth = col.maxWidth;
  
  // Commitments typically show dates or text
  const width = columnWidth ? Math.min(parseInt(columnWidth) * 0.8, 120) : "70%";
  
  return (
    <Box 
      sx={{ 
        width: columnWidth || "100%", 
        minWidth, 
        maxWidth 
      }}
    >
      <Skeleton height={16} width={width} radius="sm" />
    </Box>
  );
};